export default {
    name: 'v5-icon-close-fill',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M512 64C264.992 64 64 264.96 64 512s200.96 448 448 448c247.008 0 448-200.96 448-448S759.04 64 512 64zm182.752 585.984c12.48 12.544 12.448 32.768-.064 45.248a31.94 31.94 0 01-22.592 9.344c-8.224 0-16.416-3.136-22.656-9.408l-137.6-138.016-138.048 136.576c-6.24 6.144-14.368 9.248-22.496 9.248a31.884 31.884 0 01-22.752-9.504c-12.416-12.576-12.32-32.8.256-45.248L466.688 511.84 329.312 374.016c-12.48-12.512-12.448-32.768.064-45.248 12.512-12.512 32.736-12.448 45.248.064l137.568 137.984L650.24 330.24c12.544-12.448 32.832-12.32 45.248.256 12.448 12.576 12.32 32.832-.256 45.248L557.344 512.128l137.408 137.856z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
